import { useEffect, useState } from 'react';

/** SSR-safe matchMedia hook for responsive desk / admin layouts. */
export const useMediaQuery = (query: string): boolean => {
  const get = () => {
    try {
      return typeof window !== 'undefined' && window.matchMedia(query).matches;
    } catch {
      return false;
    }
  };
  const [matches, setMatches] = useState(get);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener?.('change', onChange);
    // Safari < 14
    mq.addListener?.(onChange);
    return () => {
      mq.removeEventListener?.('change', onChange);
      mq.removeListener?.(onChange);
    };
  }, [query]);
  return matches;
};
